import { useState } from 'react';
import { Route, NavLink, Switch, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import AllRuns from './Runs';
import SingleRun from './SingleRun';

const TabContainer = styled.div`
	margin: 15px -10px 0 -10px;
	padding-bottom: 10px;
	border-bottom: 2px solid rgba(34,36,38,.15);
`;

const CustomNavLink = styled(NavLink)`
	border-bottom-color: transparent;
	border-bottom-style: solid;
	border-bottom-width: 2px;
	border-radius: 0;
	margin: 0 0 -2px;
	transition: color .1s ease;
	color: rgba(0,0,0,.87);
	padding: 10px;
	font-size: 1em;

	:hover {
		color: rgba(0,0,0,.95);
	}

	:last-child {
		margin-left: 20px;
	}
`;

const active_tab_style = {
	color           : `rgba(0,0,0,.95)`,
	fontWeight      : 700,
	borderColor     : `#1b1c1d`,
	backgroundColor : `transparent`,
};

function Runs() {
	const location = useLocation();
	const path     = location.pathname.split(`/`).slice(-1).pop();
	const [ selected_run_id, setSelectedRunId ] = useState(path);

	const run_link = selected_run_id !== `runs` ? `/runs/${selected_run_id}` : `/runs/none`;

	function handleRunClick(id) {
		setSelectedRunId(id);
	}

	return (
		<div>
			<TabContainer>
				<CustomNavLink
					isActive={(match, location) => {
						return location.pathname === `/runs`;
					}}
					activeStyle={active_tab_style}
					to="/runs"
				>Runs</CustomNavLink>
				<CustomNavLink
					isActive={(match, location) => {
						return location.pathname !== `/runs`;
					}}
					activeStyle={active_tab_style}
					to={run_link}
				>Selected Run</CustomNavLink>
			</TabContainer>

			<Switch>
				<Route exact path="/runs">
					<AllRuns
						handleRunClick={handleRunClick}
					/>
				</Route>

				<Route exact path="/runs/:id">
					<SingleRun />
				</Route>
			</Switch>
		</div>
	);
}

export default Runs;
